import _ from 'lodash'
import moment from 'moment'
import { ValidateUtil } from '@vzmi/component_ec_nodejs_util'
import emojiRegex from 'emoji-regex'
import { numericality } from 'redux-form-validators'
import { removeSpaceAndTab } from '../components/Proposal/Common/ProposalForm/Shared/normalizers'

export const isEmptyStr = (str = '') => !ValidateUtil.removeSpaceAndNewline(_.toString(str)) && !removeSpaceAndTab(_.toString(str))
export const isNumber = (value = '') => isEmptyStr(value) ? '' : !_.isNaN(_.toNumber(value))

export const isMomentOutdated = (value, option) => {
  if (moment(value).isBefore(option.minDate) || moment(value).isAfter(option.maxDate)) {
    return true
  }
  return false
}

export const isNumberOrNumberString = (value = '') => {
  value = _.trim(value)
  if (value === '' || value === null) { return false }
  const valueToNumber = _.toNumber(value)
  const isValid = !_.isNaN(valueToNumber)
  return isValid
}

export const noEmoji = options => (valueInStore, allValues) => without({
  regex: emojiRegex(),
  msg: options.msg || '不接受 emoji'
})(valueInStore)

export const without = options => (valueInStore) => {
  const { msg = '不接受特殊符號', regex } = options
  return regex.test(_.toString(valueInStore)) ? msg : undefined
}

/** 只接受大於 0 的正整數，錯誤訊息為 '請輸入正整數' */
export const positiveInteger = (valueInStore, allValues) => numericality({ '>': 0, msg: '請輸入正整數' })(valueInStore)

export const onlyChineseValidation = options => (valueInStore, allValues) => {
  const { msg = '只接受中文字' } = options
  const isWholeChinese = /^[\u4E00-\u9FA5]*$/.test(valueInStore)
  return isWholeChinese ? undefined : msg
}
